import { ActionTypes as types } from '../constants'

export function closeGlobalToast() {
  return {
    type: types.GLOBAL_TOAST.CLOSE_GLOBAL_TOAST,
  }
}

export function showGlobalToast({ type, message, duration }) {
  return {
    type: types.GLOBAL_TOAST.SHOW_GLOBAL_TOAST,
    data: { type, message, duration },
  }
}
